module.exports = __webpack_public_path__ + "static/media/E-commerce-medical.6b14ad89.webp";